import { render, staticRenderFns } from "./CustomerVoucherTable.vue?vue&type=template&id=4cd64b48"
import script from "./CustomerVoucherTable.vue?vue&type=script&lang=js"
export * from "./CustomerVoucherTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports